import React from 'react';
import { Datagrid, TextField } from 'react-admin';
import StatusSelectField from '../../core/components/StatusSelectField';
import { categoryStatus } from './CategoryLookups';
import EditButtonWithOnClick from '../../core/components/EditButtonWithOnClick';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  label: {
    color: '#424242',
    fontSize: '14px',
    display: 'inline-block'
  },
  progress: {
    display: 'flex',
    justifyContent: 'center'
  },
  editButton: {
    color: '#757575',
    minWidth: '24px',
    padding: '6px 0',
    '& span': {
      paddingRight: 0
    }
  },
  editButtonColumnStyle: {
    width: '24px'
  }
});

const SubcategoriesDatagrid = props => {
  const {
    handleSubcategoryEditButtonClick,
    classes,
    hasWriteCategorySubcategoryPermission,
    ...dataGridProps
  } = props;

  if (dataGridProps.total > 0) {
    return (
      <Datagrid {...dataGridProps}>
        <TextField label="Subcategory Name" source="name" />
        <TextField label="Description" source="description" />
        <StatusSelectField
          label="Status"
          source="status"
          choices={categoryStatus}
        />
        {hasWriteCategorySubcategoryPermission && (
          <EditButtonWithOnClick
            label=""
            className={classes.editButton}
            headerClassName={classes.editButtonColumnStyle}
            onClick={handleSubcategoryEditButtonClick}
          />
        )}
      </Datagrid>
    );
  } else if (props.loaded) {
    return (
      <span className={classes.label}>
        There are no Subcategories to be displayed
      </span>
    );
  } else {
    return (
      <div className={classes.progress}>
        <CircularProgress />
      </div>
    );
  }
};

export default withStyles(styles)(SubcategoriesDatagrid);
